(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('FinalizeLenderDialogController', FinalizeLenderDialogController);

    FinalizeLenderDialogController.$inject = ['$mdDialog', 'orderId', 'currentLender', 'potentialLenders', 'LenderContact', 'AppraisalOrder', 'AlertService'];

    function FinalizeLenderDialogController($mdDialog, orderId, currentLender, potentialLenders, LenderContact, AppraisalOrder, AlertService) {
        var vm = this;

        vm.orderId = orderId;
        vm.currentLender = currentLender;
        vm.selectedLender = null;
        vm.selectedLenderContact = null;
        vm.lenders = potentialLenders || []; // Use passed potential lenders
        vm.lenderContacts = [];
        vm.isSaving = false;

        vm.onLenderChange = onLenderChange;
        vm.save = save;
        vm.cancel = cancel;

        console.log('Finalize Lender Dialog initialized with', vm.lenders.length, 'potential lenders'); // Debug log

        function onLenderChange() {
            vm.selectedLenderContact = null;
            vm.lenderContacts = [];
            
            if (vm.selectedLender && vm.selectedLender.id) {
                loadLenderContacts(vm.selectedLender.id);
            }
        }

        function loadLenderContacts(lenderId) {
            LenderContact.getbylender({id: lenderId}).$promise.then(function(contacts) {
                vm.lenderContacts = contacts || [];
                // Auto-select the first contact if there's only one
                if (vm.lenderContacts.length === 1) {
                    vm.selectedLenderContact = vm.lenderContacts[0];
                }
            }).catch(function(error) {
                console.error('Error loading lender contacts:', error);
                vm.lenderContacts = [];
            });
        }

        function save() {
            if (!vm.selectedLender) {
                AlertService.error('Please select a lender');
                return;
            }
            
            if (vm.lenderContacts.length > 0 && !vm.selectedLenderContact) {
                AlertService.error('Please select a lender contact');
                return;
            }

            vm.isSaving = true;

            var lenderUpdateRequest = {
                lenderId: vm.selectedLender.id
            };

            if (vm.selectedLenderContact && vm.selectedLenderContact.id) {
                lenderUpdateRequest.lenderContactId = vm.selectedLenderContact.id;
            }

            AppraisalOrder.finalizeLender({id: vm.orderId}, lenderUpdateRequest).$promise
                .then(function(response) {
                    AlertService.success('Lender updated successfully');
                    $mdDialog.hide(true);
                })
                .catch(function(error) {
                    console.error('Error finalizing lender:', error);
                    var errorMessage = 'Failed to update lender';
                    if (error.data && error.data.message) {
                        errorMessage = error.data.message;
                    }
                    AlertService.error(errorMessage);
                })
                .finally(function() {
                    vm.isSaving = false;
                });
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
